import { createSlice } from '@reduxjs/toolkit';

const matchupsSlice = createSlice({
  name: 'matchups',
  initialState: {
    null: {},
  },
  reducers: {
    setMatchup: (state, { payload }) => {
      const m = { [payload.id]: payload };
      return { ...state, ...m };
    },
    setMatchups: (state, { payload }) => {
      const ms = payload.reduce((acc, cur) => ({ ...acc, [cur.id]: cur }), {});
      return { ...state, ...ms };
    },
  },
});

export const { setMatchup, setMatchups } = matchupsSlice.actions;

export default matchupsSlice.reducer;
